import React from 'react';

import AccountGroupLockedError from './AccountGroupLockedError';
import LockedError from './LockedError';
import ManualReviewError from './ManualReviewError';
import SuspendedError from './SuspendedError';

import { Account, Customer, User } from '../data';
import { isLocked } from '../models/card';
import { isManualReview } from '../models/customer';

export interface Props {
  customer?: Customer | null;
  title: string;
  accountId: Account['id'];
  user: User;
}

const BlockedError: React.FC<React.PropsWithChildren<Props>> = ({ title, customer, accountId, user }) => {
  const isCustomerLocked = customer?.isLocked;
  const isCardLocked = customer?.card && isLocked(customer.card);
  const isCustomerInManualReview = customer && isManualReview(customer);
  const isAccountGroupLocked = user.checkingEligibilityStatus === 'account_group_locked';
  const isUserInManualReview = user.checkingEligibilityStatus === 'manual_review';
  const isSuspended =
    user.checkingEligibilityStatus === 'suspended' || user.checkingEligibilityStatus === 'suspended_documents_required';

  if (customer && (isCustomerLocked || isCardLocked)) {
    return <LockedError customer={customer} title={title} accountId={accountId} />;
  }

  if (isCustomerInManualReview || isUserInManualReview) {
    return <ManualReviewError title={title} />;
  }

  if (isAccountGroupLocked) {
    return <AccountGroupLockedError title={title} />;
  }

  if (isSuspended) {
    return <SuspendedError title={title} />;
  }
  return null;
};
export default BlockedError;
